export default "__VITE_PUBLIC_ASSET__df98b646__"